import React, { memo } from 'react';
import { Star, MapPin } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
export function Testimonials() {
  const testimonials = [{
    name: 'Carolina R.',
    location: 'Mendoza',
    role: 'Estudiante de 5° año',
    text: 'El mapa de tests me cambió la cabeza. Antes hacía tests al azar. Ahora sé exactamente cuál usar y por qué. Mi tutor de prácticas lo notó enseguida.'
  }, {
    name: 'Matías L.',
    location: 'Buenos Aires',
    role: 'Kinesiólogo junior',
    text: 'El Tomo 6 con los casos clínicos es lo que me faltaba para conectar la evaluación con el diagnóstico funcional. Lo recomiendo a cualquiera que esté en el internado.'
  }, {
    name: 'Sofía C.',
    location: 'La Plata',
    role: 'Estudiante de internado',
    text: 'Las plantillas del Bono 3 me salvan en cada práctica. Llego con la ficha de la región, evalúo en orden y no me olvido de nada. Mis compañeros me piden copias.'
  }, {
    name: 'Pablo A.',
    location: 'Rosario',
    role: 'Kinesiólogo recién graduado',
    text: 'El compendio de tests con los valores de sensibilidad y especificidad me ayudó a entender de verdad para qué sirve cada prueba. Antes los memorizaba. Ahora los entiendo.'
  }, {
    name: 'Lucía M.',
    location: 'Córdoba',
    role: 'Estudiante de 4° año',
    text: 'El plan de 21 días fue clave. Tenía el material pero no sabía por dónde empezar. El plan me dio un camino claro y llegué a la práctica mucho más preparada.'
  }];
  return <AnimatedSection data-id="element-304">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-305">
        <h2 className="text-2xl sm:text-3xl md:text-5xl font-heading font-bold text-center mb-12 sm:mb-16 leading-tight" data-id="element-306">
          ❤️ MÁS ESTUDIANTES Y KINESIÓLOGOS QUE YA LO TIENEN
        </h2>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-4 sm:gap-6 space-y-4 sm:space-y-6" data-id="element-307">
          {testimonials.map((t, idx) => <div key={idx} className="break-inside-avoid bg-dark-card border border-dark-border rounded-xl p-5 sm:p-6 shadow-lg hover:border-gold/30 transition-colors" data-id="element-308">
              <div className="flex gap-1 mb-3 sm:mb-4" data-id="element-309">
                {[...Array(5)].map((_, i) => <Star key={i} size={14} className="fill-gold text-gold" data-id="element-310" />)}
              </div>
              <p className="text-gray-300 text-sm sm:text-base mb-5 sm:mb-6 italic leading-relaxed" data-id="element-311">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 sm:gap-4" data-id="element-312">
                <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-navy-800 border border-gold/30 flex items-center justify-center text-gold font-bold font-heading text-sm sm:text-base flex-shrink-0" data-id="element-313">
                  {t.name.charAt(0)}
                </div>
                <div className="min-w-0" data-id="element-314">
                  <div className="font-bold text-white text-sm sm:text-base truncate" data-id="element-315">
                    {t.name}
                  </div>
                  <div className="text-xs text-gray-400 flex items-center gap-1" data-id="element-316">
                    <MapPin size={11} className="flex-shrink-0" data-id="element-317" />{' '}
                    <span className="truncate" data-id="element-318">
                      {t.location} | {t.role}
                    </span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </AnimatedSection>;
}